import React from "react";
import "./Item.css";
import { Link } from "react-router-dom";
import default_img from "../../Components/Assets/default_img.png";
import WishlistButton from "../WishlistButton/WishlistButton";

const Item = (props) => {
  const handleNavigate = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="item-card">

      {/* IMAGE SECTION */}
      <div className="item-img-container">

        {/* Wishlist Icon */}
        <WishlistButton
          productId={props.id}
          isWishlisted={props.is_wishlist}
          className="wishlist-btn"
        />

        {/* Product Image */}
        <Link to={`/product/${props.id}`} onClick={handleNavigate}>
          <img
            src={props.image || default_img}
            alt={props.name}
            loading="lazy"
          />
        </Link>

      </div>

      {/* INFO SECTION */}
      <div className="item-info">
        <p className="item-name">{props.name}</p>

        <div className="item-prices">
          <span className="price-new">₹{props.new_price}</span>
          {props.old_price && (
            <span className="price-old">₹{props.old_price}</span>
          )}
        </div>
      </div>

    </div>
  );
};

export default Item;
